import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneStatusTypes,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import AddNewGamePeriod from "../../component/addNewGamePeriod/AddNewGamePeriod";
import {useNavigate} from "react-router-dom";
import {GamePeriodService} from "../../serverService/gameService/GamePeriodService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {GamePeriodsTypes} from "./GamePeriodTypes";

export default function GamePeriod() {


    let page = 0;
    const size = 20;

    const service = new GamePeriodService();

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [periodGameListData, setPeriodGameListData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);


    useEffect(() => {
        if (service) {
            getDataFromServer()
        }
    }, []);

    function getDataFromServer() {
        setTableLoading(true)
        service.getGamePeriods(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setPeriodGameListData([])
                response.data.map((item, index) => {
                    setPeriodGameListData(prev => [
                        ...prev,
                        gamePeriodRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.registrationStartDate,
                            item.registrationEndDate,
                            item.competitionStartDate,
                            item.competitionEndDate,
                            GamePeriodsTypes[item.status],
                            item.createdBy,
                            item.createdAt,
                        )
                    ])
                })
            }).catch(error => {
            showServerErrorMessage(new ServerErrorHandler(error).getMessage())
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function gamePeriodRow(
        id,
        number,
        periodName,
        registrationStartDate,
        registrationEndDate,
        periodStartDate,
        periodEndDate,
        status,
        createdBy,
        createdAt
    ) {
        return {
            id,
            number,
            periodName,
            registrationStartDate: convertUniversalDateToPersianDate(registrationStartDate),
            registrationEndDate: convertUniversalDateToPersianDate(registrationEndDate),
            periodStartDate: convertUniversalDateToPersianDate(periodStartDate),
            periodEndDate: convertUniversalDateToPersianDate(periodEndDate),
            status: status === GamePeriodsTypes.IN_PROGRESS || status === GamePeriodsTypes.SCHEDULED || status === GamePeriodsTypes.REGISTRATION_OPEN ?
                <RaikoCustomSimpleChip title={status.title} type={RaikoChipTypes.warning}/> :
                status === GamePeriodsTypes.COMPLETED ?
                    <RaikoCustomSimpleChip title={status.title} type={RaikoChipTypes.success}/> :
                    <RaikoCustomSimpleChip title={status.title} type={RaikoChipTypes.error}/>,
            acceptationStatus: status,
            createdBy,
            createdAt: convertUniversalDateToPersianDate(createdAt),
        }

    }


    const [openAddNewGamePeriodDialog, setOpenAddNewGamePeriodDialog] = useState(false)

    function handleOpenDialog() {
        setOpenAddNewGamePeriodDialog(true)
    }

    function handleCloseDialog() {
        setOpenAddNewGamePeriodDialog(false)
    }

    const navigate = useNavigate()

    function goToGamePeriodDetails(gamePeriodId) {
        let _title = ""
        periodGameListData.map((item) => {
            if (item.id === gamePeriodId)
                _title = item.periodName
        })

        navigate(RouteHelper.GamePeriodDetails.globalUrl.replace(":gamePeriodId", gamePeriodId),
            {state: {title: _title}, replace: false}
        )
    }

    function handleAddNewGamePeriodRow(item) {
        const _items = addNewRowToTable(
            gamePeriodRow(
                1,
                item.id,
                item.title,
                item.registrationStartDate,
                item.registrationEndDate,
                item.competitionStartDate,
                item.competitionEndDate,
                GamePeriodsTypes[item.status],
                item.createdBy,
                item.createdAt,
            ),
            periodGameListData
        );
        setPeriodGameListData(_items)

    }

    return (
        <>
            <Helmet><title>{RouteHelper.GamePeriod.name}</title></Helmet>
            <RaikoDefaultDialogPage
                pageTitle={""}
                onClose={handleCloseDialog}
                open={openAddNewGamePeriodDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewGamePeriod
                    handleCloseDialog={handleCloseDialog}
                    handleAddNewGamePeriodToTable={handleAddNewGamePeriodRow}
                />

            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Game.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.GamePeriod.name, ""),
                    ]}/>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={RouteHelper.GamePeriod.name}
                            amount={numberOfItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoCustomTable
                            header={gamePeriodListHeader}
                            data={periodGameListData}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            selectDisplayType={selectDisplayType}
                            rowClicked={goToGamePeriodDetails}
                        >
                            <RaikoGridTwoColumn className={css`padding: 3px`}>
                                {
                                    periodGameListData.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            iconClass={"ic-game-play"}
                                            title={item.periodName}
                                            status
                                            statusText={item.acceptationStatus.title}
                                            statusType={
                                                item.acceptationStatus === GamePeriodsTypes.IN_PROGRESS ||
                                                item.acceptationStatus === GamePeriodsTypes.SCHEDULED ||
                                                item.acceptationStatus === GamePeriodsTypes.REGISTRATION_OPEN ?
                                                    RaikoCardInfoTypeOneStatusTypes.WARNING :
                                                    item.acceptationStatus === GamePeriodsTypes.COMPLETED ?
                                                        RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR
                                            }
                                            titleLabel={` ${item.periodStartDate}  الـــــــی  ${item.periodEndDate} `}
                                            onClick={() => {
                                                goToGamePeriodDetails(item.id)
                                            }}
                                        />
                                    })
                                }

                            </RaikoGridTwoColumn>

                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>


        </>
    )
}

const gamePeriodListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "periodName",
        label: "نام دوره زمانی"
    },
    {
        id: "registrationStartDate",
        label: "تاریخ شروع ثبت نام",
    },
    {
        id: "registrationEndDate",
        label: "تاریخ پایان ثبت نام"
    },
    {
        id: "periodStartDate",
        label: "تاریخ شروع دوره"
    },
    {
        id: "periodEndDate",
        label: "تاریخ پایان دوره"
    },
    {
        id: "status",
        label: "وضعیت"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
]